import styled from 'styled-components'

export const SearchStyle = styled.div`
  display: flex;
  alight-items: center;
  padding: 2rem;
  input {
    width: 100%;
    color: #4f4f4f;
    font-size: 2rem;
    background-color: inherit;
    border: none;
    outline: none;
    svg {
      width: 2.4rem;
      margin-right: 2rem;
      flex-shrink: 0;
  }`
